import { render, staticRenderFns } from "./VotersGuide.vue?vue&type=template&id=c56b7f52"
import script from "./VotersGuide.vue?vue&type=script&lang=js"
export * from "./VotersGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports